import { useMutation } from '@tanstack/react-query';

import type { CreateRiskBandSetPayload } from 'api/RiskBandsApi';
import { RiskBandsApi } from 'api/RiskBandsApi';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { RISK_BANDS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useCreateRiskBandSet() {
  const riskBandsApi = new RiskBandsApi();
  const { userBankId } = useUser();
  const { invalidateRiskBandSets } = useFiRiskAssessmentCache();

  const { mutateAsync: createRiskBandSet, isPending: isCreatingRiskBandSet } = useMutation({
    mutationKey: [RISK_BANDS_KEY, 'create'],
    mutationFn: (data: CreateRiskBandSetPayload) => riskBandsApi.createRiskBandSet(userBankId, data),
    onSuccess: () => {
      invalidateRiskBandSets();
    },
    meta: {
      snackbarSuccessMessage: 'Risk bands saved.',
      snackbarErrorMessage: 'There was an issue creating the risk band set. Please contact support.'
    }
  });

  return { createRiskBandSet, isCreatingRiskBandSet };
}
